// extracted by mini-css-extract-plugin
export default {"headerBar":"newMetricResults_headerBar__gmmfI"};